import { tourStep } from './tourRegistry';

export const bandaRepertorioSteps = [
  tourStep(
    'repertorio-tabs',
    'Archivo musical',
    'Cinco pestañas: <strong>Biblioteca</strong> (obras), <strong>Carpetas</strong>, <strong>Voces e instrumentos</strong>, <strong>Compartir repertorio</strong> (enlace) y <strong>Estadísticas</strong> de uso.',
  ),
  tourStep(
    'repertorio-add',
    'Añadir obras',
    'Sube PDFs o imágenes, también una carpeta completa. La IA separa obras y páginas; quedan en borrador para que las revises. Cuenta contra el tope de obras, páginas y disco de tu plan.',
  ),
  tourStep(
    'repertorio-filtros',
    'Buscar y páginas sueltas',
    'Filtra por título, autor, género o estado. El interruptor <strong>Páginas sueltas</strong> muestra cada página del archivo (útil para vocería).',
  ),
  tourStep(
    'repertorio-list',
    'Listado de obras',
    'Abre una obra para ver páginas, etiquetas, carpetas y cuántas veces se ha programado en ensayos o actuaciones.',
    'top',
  ),
];
